import React, { FunctionComponent } from 'react';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import Button from '@liveramp/motif/core/Button';
import useClientBoundingRect from 'shared/hooks/useClientBoundingRect';
import styles from '../styles.module.scss';

interface Props {
  onClick: () => void;
  label: string;
  FilterComponent: FunctionComponent<{buttonBoundingRect: ClientRect | null}>;
  color?: string;
  variant?: string;
  isFilterComponentOpened: boolean;
}

const FilterButton: FunctionComponent<Props> = ({
  onClick,
  label,
  FilterComponent,
  color = 'secondary',
  variant = 'outlined',
  isFilterComponentOpened
}) => {
  const [buttonRef, buttonBoundingRect] = useClientBoundingRect(isFilterComponentOpened);

  return (
    <>
      <Button
        className={`${styles.filterButton}  ${color === 'primary' ? styles.filterActive : ''}`}
        data-test-id="filter-archiving-select"
        onClick={onClick}
        variant={variant}
        color={color}
      >
        <div
          className={styles.buttonContent}
          ref={buttonRef}
        >
          <div className={styles.buttonLabel}>{label}</div>
          <div className={styles.buttonDropDownIcon}><ArrowDropDown /></div>
        </div>
      </Button>
      <FilterComponent
        buttonBoundingRect={buttonBoundingRect}
      />
    </>
  );
};

export default FilterButton;
